
import Vue from 'vue'
//国际化语言包
import VueI18n from 'vue-i18n'
Vue.use(VueI18n)
import messages from './lang/index'

/**
 * 从localStorage中拿到用户的语言选择，如果没有，那么默认为中文
 */
const i18n = new VueI18n({
  locale: localStorage.getItem('lang') || 'zh',    // 语言标识, 通过切换locale的值来实现语言切换,this.$i18n.locale
  messages
})

export default i18n



// WEBPACK FOOTER //
// ./src/common/i18n.js